const settings = {
    development: {
        showFps: true,
    },
};

// Vendor
import DrawSVGPlugin from './vendor/gsap/DrawSVGPlugin';

// Utilities
import FpsDisplay from './utilities/fps-display';
import {SiteSection} from './utilities/site-section';

// Components
import ViewportScaledElement from './components/viewport-scaled-element';
import AnchorLinks from './components/anchor-links';
import ResponsiveVideoLoader from './components/responsive-video-loader';
import References from './components/references';
import Header from './components/header/header';
import ScrollAnimation from './components/scroll-animation';
import HeroCircles from './components/hero-circles';
import HomepageHero from './components/hero-homepage';
import ImageZoomModal from './components/image-zoom-modal';
import ImageCarouselModal from './components/image-carousel-modal';
import VideoModal from './components/video-modal';
import HotSpotIllustration from './components/hotspot-illustration';
import TabSection from './components/tab-section';
import ChairGallerySection from './components/chair-gallery-section';
import AudioTooltip from './components/audio-tooltip/audio-tooltip';
import ImageComparison from './components/image-comparison';
import VideoPlayButton from './components/video-play-button';
import ComorbiditiesIllustration from './components/comorbidities-illustration';
import ManifestationStatues from './components/manifestation-statues';
import VideoCircleScreensScroll from './components/video-circle-screens-scroll';

// Vendor initialization
gsap.registerPlugin(DrawSVGPlugin);

// Load our current site section identifier
SiteSection.init();

// Setup common components
ViewportScaledElement.init();
ResponsiveVideoLoader.init();
References.init();
Header.init();
ScrollAnimation.init();
HeroCircles.init();
HomepageHero.init();
ImageZoomModal.init();
ImageCarouselModal.init();
VideoModal.init();
HotSpotIllustration.init();
TabSection.init();
ChairGallerySection.init();
AudioTooltip.init();
ImageComparison.init();
VideoPlayButton.init();
ComorbiditiesIllustration.init();
ManifestationStatues.init();
VideoCircleScreensScroll.init();
AnchorLinks.init();

// Environment-specific settings
// Note: originally this project was set up to run Gulp such that
// "env" would be set to "development" by default, but since the
// themes folder is now set up to exactly match what's in the
// Drupal "rheumuseum" repository, that's been disabled to avoid
// these files getting copied over there, compiled with dev settings,
// and that output making its way to UCB's servers by accident.
// As a backup we're just checking if the hostname is "localhost"
// or an IP address
let devMode = __env == 'development';
if (!devMode) {
    devMode = /^localhost|\d+\.\d+\.\d+\.\d+$/.test(window.location.hostname);
}

if (devMode) {
    console.info(
        '%c\u2605%cDevelopment%c\u2605',
        'display: inline-block; color: #ff451a; padding: 0px 4px; background-color: #000; border-top-left-radius: 4px; border-bottom-left-radius: 4px; border: solid 1px #ff451a; border-right: none;',
        'display: inline-block; color: #fff; padding: 0px; background-color: #000; border: solid 1px #ff451a; border-left: none; border-right: none;',
        'display: inline-block; color: #ff451a; padding: 0px 4px; background-color: #000; border-top-right-radius: 4px; border-bottom-right-radius: 4px; border: solid 1px #ff451a; border-left: none;',
    );

    // Show FPS if we're configured to do so
    if (settings.development.showFps) {
        FpsDisplay.init();
    }
}

// Remove the "preload" class from any elements it's applied to
document.addEventListener('DOMContentLoaded', () => {
    const preloadElements = document.querySelectorAll('.preload');
    for (let i=0; i<preloadElements.length; i++) {
        preloadElements[i].classList.remove('preload');
    }
});
